export default __webpack_public_path__ + "static/media/title_sp.6ba9967f.png";